export function normalizeRichTextHtml(html: string | null | undefined): string {
  const normalizedSpaces = (html || '').replace(/&nbsp;/g, ' ');

  if (!normalizedSpaces || typeof DOMParser === 'undefined') {
    return normalizedSpaces;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${normalizedSpaces}</div>`, 'text/html');
  const root = doc.body.firstElementChild as HTMLDivElement | null;

  if (!root) {
    return normalizedSpaces;
  }

  normalizeQuillLists(root, doc);
  unwrapListOnlyItems(root);

  return root.innerHTML;
}

function normalizeQuillLists(root: HTMLDivElement, doc: Document): void {
  const orderedLists = Array.from(root.querySelectorAll('ol'));

  for (const ol of orderedLists) {
    const liItems = Array.from(ol.children).filter((node) => node.tagName === 'LI') as HTMLLIElement[];
    if (liItems.length === 0 || !liItems.some((li) => li.hasAttribute('data-list'))) {
      continue;
    }

    const replacement = doc.createDocumentFragment();
    let currentList: HTMLOListElement | HTMLUListElement | null = null;
    let currentListTag: 'ol' | 'ul' | null = null;

    for (const li of liItems) {
      const listMode = li.getAttribute('data-list');
      const targetTag: 'ol' | 'ul' = listMode === 'bullet' ? 'ul' : 'ol';

      if (!currentList || currentListTag !== targetTag) {
        currentList = doc.createElement(targetTag);
        replacement.appendChild(currentList);
        currentListTag = targetTag;
      }

      const newLi = doc.createElement('li');
      for (const attr of Array.from(li.attributes)) {
        if (attr.name !== 'data-list') {
          newLi.setAttribute(attr.name, attr.value);
        }
      }
      while (li.firstChild) {
        newLi.appendChild(li.firstChild);
      }
      currentList.appendChild(newLi);
    }

    ol.replaceWith(replacement);
  }
}

function unwrapListOnlyItems(root: HTMLDivElement): void {
  root.querySelectorAll('li').forEach(li => {
    const childLists = Array.from(li.children).filter(
      child => child.tagName === 'UL' || child.tagName === 'OL'
    );
    const textWithoutChildLists = Array.from(li.childNodes)
      .filter(node => !(node.nodeType === Node.ELEMENT_NODE && ['UL', 'OL'].includes((node as Element).tagName)))
      .map(node => node.textContent || '')
      .join('')
      .replace(/\u00a0/g, ' ')
      .trim();

    if (childLists.length === 1 && !textWithoutChildLists) {
      const childList = childLists[0];
      const parentList = li.parentElement;

      if (parentList && (parentList.tagName === 'UL' || parentList.tagName === 'OL')) {
        Array.from(childList.children).forEach(childListItem => {
          parentList.insertBefore(childListItem, li);
        });
        li.remove();
      } else {
        li.replaceWith(childList);
      }
    }
  });
}
